// @ts-nocheck
/* eslint-enable */
// Actions
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

const fetchNearbyAreasListings = (reactContext, { areaResourceId }) => {
  const { store, trace } = reactContext;

  return store
    .dispatch(ListingEngineActions.fetchNearbyAreasListings(areaResourceId))
    .then((response) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#fetchNearbyAreasListings',
      });

      return response;
    })
    .catch((error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#fetchNearbyAreasListings',
          errorClass: 'listingEngineActions',
        }),
      );
    });
};

export default fetchNearbyAreasListings;
